import classNames from 'classnames'
import { ReactElement } from 'react'
import { ContactNameIcon } from '../contacts/ContactNameIcon'
import PhoneNumber from '../PhoneNumber'
import type { ContactJson } from 'app/types/entities'
import { sanitizeName } from 'app/sanitize-name'
/**
 * Contact name with Icon and matched contact status
 * @param contact Contact information
 * @param matchedContact Matched contact
 * @returns Component with contact information
 */
export function ContactCell({
  contact,
  matchedContact,
  showCellPhone = false,
}: {
  contact: ContactJson
  matchedContact?: ContactJson | null
  showCellPhone?: boolean
}): ReactElement {
  return (
    <span className="flex items-center gap-x-2 font-bold capitalize outline-none">
      <ContactNameIcon contact={contact} heightClassName={`h-5`} widthClassName={`w-5`} isTiny />
      <span className="flex flex-col justify-center">
        <span
          className={classNames(
            contact.patientStatus === `NonPatient` ? `text-red-500` : undefined,
            `overflow-hidden overflow-ellipsis whitespace-nowrap text-body-xs font-bold!`,
          )}
        >
          {sanitizeName(contact.name)?.toLocaleLowerCase()}
        </span>
        {matchedContact?.id === contact.id && <span className="text-caption-sm text-subtle">Current</span>}
        {showCellPhone && contact.cellPhone && (
          <PhoneNumber number={contact.cellPhone} className="text-caption-sm text-subtle" />
        )}
      </span>
    </span>
  )
}
